module.exports = __webpack_public_path__ + "img/pic_02@2x.2e498149.png";